export const EXAMPLE_TOOLBAR_BUTTONS_CONFIG = [
  {
    "header": true,
    "title": "My Application",
    "color": "#1d1358",
    "logo": "data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"%236950ff\" viewBox=\"0 0 1500 1500\"><path d=\"m736.7 1143.8-.9-1.2-4.7-6-410-505.5-205.3 251.7L292.1 1100c34.6 51.6 103.8 80.2 173 80.2h303.4a687 687 0 0 1-31.8-36.4M936 758.7l-221.6 273 6.3 8.2 52.3 64.4 3.7 4.8 1 1.1c5.6 7 13.9 17 23.4 27.4a127 127 0 0 0 85.9 42.6h.7c67.7 0 149.2 6 186-42.9l85-104.8zM874.5 357l.9 1.2 4.7 6L1179 731.5l205.2-251.7-65.1-79c-34.7-51.6-103.8-80.2-173-80.2H842.6c11 11.7 21.7 24.2 31.8 36.4M675.1 742l221.6-273-6.2-8-52.3-64.5-3.7-4.8-1-1.1c-5.7-7-14-17-23.4-27.4a127 127 0 0 0-85.9-42.6h-.7c-66-.3-140.6-10.8-186 42.9l-85 104.8z\"/></svg>"
  },
  {
    "label": "Perspective {{current_perspective}}",
    "icon": "lucide-layout-panel-left",
    "buttons": [
      {
        "label": "Primary",
        "actions": [
          {
            "type": "set-perspective",
            "areaId": ""
          }
        ]
      },
      {
        "label": "Secondary",
        "actions": [
          {
            "type": "set-perspective",
            "areaId": "2nd"
          }
        ]
      },
      {
        "label": "Tertiary",
        "actions": [
          {
            "type": "set-perspective",
            "areaId": "3rd"
          }
        ]
      }
    ]
  },
  {
    "spacer": true
  },
  {
    "icon": "lucide-help-circle",
    "label": "Help",
    "actions": [
      {
        "type": "open-popup",
        "areaId": "help",
        "title": "Help",
        "minWidth": "min(1000px, 95vw)",
        "maxWidth": "95vw",
        "minHeight": "min(500px, 90vh)"
      }
    ]
  },
  {
    "icon": "lucide-info",
    "label": "Info",
    "actions": [
      {
        "type": "open-popup",
        "areaId": "info",
        "title": "About"
      }
    ]
  },
  {
    "icon": "lucide-bug",
    "label": "Run rule",
    "actions": [
      {
        "type": "start-rule",
        "startRule": "random",
        "parameters": {},
        "timestampVariable": "update"
      }
    ]
  },
  {
    "icon": "lucide-play",
    "label": "Pubsub",
    "actions": [
      {
        "type": "publish",
        "topic": "randomTopic",
        "value": "{{uuid}}"
      }
    ]
  }
]
